<template>
  <el-card class="box-card">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }">Panel</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ path: '/dashboard/' + $route.params.db + '/notificaciones_periodicas'}"
      >Notificaciones</el-breadcrumb-item>
      <el-breadcrumb-item v-if="$route.params.id">Editando Notificación</el-breadcrumb-item>
      <el-breadcrumb-item v-else>Nueva Notificación</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <h2>{{form.asunto}}</h2>
    <el-form @submit.native.prevent="submit" ref="form" label-position="top" id="form">
      <el-row type="flex" justify="space-between">
        <el-col>
          <el-form-item label="Día de cada mes que se envía la notificación">
            <el-select v-model="form.dia" placeholder="Select">
              <el-option
                v-for="item in dias"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
<el-col>
          <el-form-item label="¿Activo?">
            <el-switch v-model="form.activo"
            active-value="1"
    inactive-value="2">>
</el-switch>
            </el-select>
          </el-form-item>
        </el-col>
        </el-row>
  <el-row >

        <el-col>
          <el-form-item label="Asunto">
<el-input  v-model="form.asunto"></el-input>          </el-form-item>
        </el-col></el-row><el-row >
 <el-col>

          <el-form-item label="Mensaje">
<el-input
  type="textarea"
  :rows="5"

  v-model="form.texto">
</el-input>       </el-form-item> </el-col>


      </el-row>

      <el-row class="mb-5">
<el-col>
     <el-form-item label="Destinatarios">
    <app-modal-add-auth  :table="tableAuth" :data="idAuth" v-if="showPermisos" ></app-modal-add-auth>
     </el-form-item>
</el-col>
      </el-row>
    </el-form>



    <el-row>
      <el-col :span="24">
        <button type="submit" class="el-button el-button--primary" form="form">
          <span>Guardar</span>
        </button>

        <el-button v-if="!$route.params.section_id" @click="close()">Cancelar</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import notificationform from "@/components/Dashboard/home/notificationform";
import addAuth from "@/components/_commons/auth/addAuth";

import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import moment from "moment-timezone";

import {
  FECTH_TIPO_TEMPLATE_DESKTOP,
  FECTH_PAGINA_ACTIVA,
  FECTH_PAGE
} from "@/store/actions.type";
import { SET_TIPO_TEMPLATE_DESKTOP } from "@/store/mutations.type";

export default {
  name: "NotificacionesForm",
  components: {
    "app-notification-form": notificationform,
    "app-modal-add-auth": addAuth
  },
  async created() {
    if (this.$route.params.id) {
        this.init();
        }else{
            this.showPermisos=true;
        }

    for (let i = 1; i < 32; i++) {
      this.dias.push({ label: "Día " + i, value: i });
    }
 this.$root.$on("guardarPermisos", frm => {
      this.frm_permisos=frm;
    });

  },
  data() {
    return {
        frm_permisos:[],
        idAuth:0,
        tableAuth: "notificaciones_cron",
        showPermisos:false,
      dias: [],
      reload_table: 0,
      fullscreenLoading: false,
      show_procesar: false,
      reload_upload: 0,
      documento: [],
      pickerOptions1: {
        firstDayOfWeek: 1
      },
      showEditPermisos: true,

      // show,s
      showTabla: false,



      // form
      id: null,
      form: {
        asunto: "",
        texto: "",
        activo:2,
        dia:1

      },

      templates: null,
      errorTitle: false,

      // paginate
      tableData: [],
      routeEdit: false,
      tableColumns: [
        {
          label: "Usuario",
          prop: "users"
        },
        {
          label: "Nomina",
          prop: "pdf",
          type: "file"
        }
      ],
      tableDelete: false,
      preview: false,

      // notification
      notification: false,
      notification_id: false
    };
  },
  methods: {
    async init() {

         this.idAuth = parseInt(this.$route.params.id);
         await this.getDesktop();
        this.showPermisos=true;
    },
    handleRemove(file) {
      this.documento = [];
      this.form.pdf = "";
    },
    handleChange(file) {
      console.log([file]);
      this.documento = [{ file, field: "pdf" }];
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },

async getDesktop() {
      const response = await ApiService.post("dashboard/table", {
        table: "notificaciones_cron",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id
      });
      this.form = response.data;



    },


    async submit() {



      const response = await ApiService.post("dashboard/editform", {
        table: "notificaciones_cron",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id
      });
      let id=response.data;
if (this.$route.params.id){
id=this.$route.params.id;

}

if (this.frm_permisos.length>0){
    const resp= await ApiService.put("dashboard/update-desktop-auth", {
          table: "notificaciones_cron",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: this.frm_permisos,
          id: id,
          tableAuth: "notificaciones_cron"
        }).then(response => {
          if (response.data) {
            this.$message({
              type: "success",
              message: "Permisos actualizados"
            });
          }

        });
}
      this.$router.replace("/dashboard/" + this.$route.params.db + "/notificaciones_periodicas");
    },

    async close() {
      await this.$router.replace(
        "/dashboard/" + this.$route.params.db + "/notificaciones_periodicas"
      );
    },
    loading() {
      this.fullscreenLoading = true;
    }
  }
};
</script>
<style>
.disabled {
  background-color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/notificaciones_cron/form.vue